import { api, ApiResponse } from './api'

export interface PreRegistrationData {
  email: string
  firstName?: string
  lastName?: string
  company?: string
  role?: string
  useCase?: 'procurement' | 'vc' | 'm&a' | 'cto' | 'other'
  message?: string
}

export interface PreRegistrationResponse {
  id: string
  email: string
  createdAt: string
  status: 'pending' | 'confirmed'
}

/**
 * Submit a pre-registration request
 * Note: In development, this may fail if the backend endpoint doesn't exist yet.
 * The form will handle this gracefully.
 */
export const submitPreRegistration = async (
  data: PreRegistrationData
): Promise<PreRegistrationResponse> => {
  try {
    const response = await api.post<PreRegistrationResponse>(
      '/preregistration',
      data
    )
    return response.data
  } catch (error) {
    console.error('Pre-registration submission failed:', error)
    // In development, if endpoint doesn't exist, simulate success
    if (import.meta.env.DEV) {
      console.warn(
        'Pre-registration endpoint not available. Simulating success for development.'
      )
      return {
        id: `dev_${Date.now()}`,
        email: data.email,
        createdAt: new Date().toISOString(),
        status: 'pending',
      }
    }
    throw error
  }
}

